import { SvgIcon } from '@bob/library'
import { Icons } from '@bob/library/dist/SvgIcon/Icons'
import clsx from 'clsx'
import { box, button, listItem, styles } from 'leds'
import React, { FC } from 'react'

export type SidebarItemIconProps = {
  label: string
  icon: keyof typeof Icons
  onClick: () => void
  selected?: boolean
}

export const SidebarItemIcon: FC<SidebarItemIconProps> = ({ label, icon, onClick, selected }) => (
  <div className={clsx(styles({ paddingLeft: 16 }), listItem({ level: 'first' }))}>
    <div
      className={
        selected
          ? box({
              type: 'icon',
              border: 'full',
              borderColor: 'blue5',
              rounded: 'small',
              background: 'whiteBlue',
            })
          : box({ type: 'icon' })
      }
      data-testid={`icon-selected-${selected}`}
    >
      <button
        aria-label={label}
        className={button({ type: 'icon' })}
        data-testid={`icon-button`}
        onClick={onClick}
      >
        <SvgIcon color={'black'} name={icon} size={24} title={label} />
      </button>
    </div>
  </div>
)
